export const state = {
  cidade: null,
  uf: null,
  bairro: null,
  enderecoFormatado: null
}

export const getters = {
  cidade: state => state.cidade,
  uf: state => state.uf,
  bairro: state => state.bairro,
  enderecoFormatado: state => state.enderecoFormatado
}

export const mutations = {
  setCidade (state, payload) {
    state.cidade = payload
  },
  setUf (state, payload) {
    state.uf = payload
  },
  setBairro (state, payload) {
    state.bairro = payload
  },
  setEnderecoFormatado (state, payload) {
    state.enderecoFormatado = payload
  }
}

function getTipoEndereco (place, type, format) {
  var addressComponent = place.address_components
  for (let i = 0; i < addressComponent.length; i++) {
    const element = addressComponent[i]
    if (containsType(element, type)) {
      if (format) {
        return element[format]
      } else {
        return element.long_name
      }
    }
  }
}

function containsType (element, pTypes) {
  const types = pTypes.split(',')

  for (const findType in types) {
    if (element.types.indexOf(types[findType]) > -1) {
      return true
    }
  }
  return false
}

export const actions = {
  setLocal ({ getters, commit }, place) {
    console.log('Place', place)
    commit('setEnderecoFormatado', place.formatted_address)

    commit('setCidade', getTipoEndereco(place, 'locality,administrative_area_level_2'))
    commit('setUf', getTipoEndereco(place, 'administrative_area_level_1', 'short_name'))
    commit('setBairro', getTipoEndereco(place, 'sublocality_level_1'))
  }
}



// WEBPACK FOOTER //
// ./src/store/local/index.js